export class LocalStorageKeys {
    public static AUTH_TOKEN = 'auth-token';
}
